import React, { forwardRef, useState } from "react";
import styles from "./student-gallery.module.scss";
import FocusPointImg from "~components/utils/focusPointImg";
import Components from "~components/components";
import { css } from "@emotion/core";

const StudentGalleryItem = forwardRef((props: any, ref) => {
  const {
    action,
    image,
    autoAdjustSize,
    exchange_country,
    exchange_country_text,
    onMouseEnter,
    onMouseLeave,
    handleStop,
    handlePlay,
    modal_title,
    story,
  } = props;

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
    handleStop();
  };
  const handleClose = () => {
    setOpen(false);
    handlePlay();
  };

  const modalStyles = css`
    .ef-modal__dismiss {
      z-index: 999999;
    }

    .ef-modal__content {
      .ef-fullbleed {
        margin-left: -64px;
        margin-right: -64px;
      }
    }
  `;

  return image?.image ? (
    <>
      {action && action[0]
        ? Components(
            {
              ...action[0],
              open,
              handleOpen,
              handleClose,
              style: modalStyles,
              modalTitle: modal_title,
            },
            story
          )
        : null}
      <div
        className={`${styles.card} -gradient-mid`}
        // @ts-ignore
        ref={ref}
        onMouseEnter={open ? handleStop() : onMouseEnter}
        onMouseLeave={open ? handleStop() : onMouseLeave}
        onClick={() => handleOpen()}
      >
        <FocusPointImg
          autoAdjustSize={autoAdjustSize}
          focusPoint={image}
          className="ef-card--teaser__img"
          alt={""}
        />
        <p className={styles.cardTitle}>
          {/** TODO: temporary fix using join.efhighschool url to fix svg not loading */}
          {exchange_country ? (
            <img
              className={`flag--image ${styles.cardTitleFlag}`}
              style={{ borderRadius: 0 }}
              alt={`${exchange_country} flag`}
              src={`https://join.efhighschool.com/${exchange_country}.svg`}
            />
          ) : null}
          {exchange_country_text}
        </p>
      </div>
    </>
  ) : null;
});

export default StudentGalleryItem;
